import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const PATIENTS_BY_DOCTOR_CONTANTS = {
  id: 'report.patientsByDoctor',
  title: 'Reporte: Pacientes por Doctor',
  labels: {
    ...COMMONS,
  },
  actions: {
    ...ACTIONS
  }
};
